{
  "hero": {
    "title": "Contact"
  },
  "intro": {
    "text": "Pentru proiecte de video, design sau soluții digitale, completați formularul sau folosiți datele de contact de mai jos."
  },
  "form": {
    "title": "Trimiteți un mesaj",
    "fields": {
      "fullName": {
        "label": "Nume complet"
      },
      "email": {
        "label": "Email"
      },
      "message": {
        "label": "Mesaj"
      }
    },
    "submit": "Trimite mesaj",
    "sending": "Se trimite...",
    "success": "Mesajul a fost trimis.",
    "error": "Mesajul nu a putut fi trimis. Reluați trimiterea."
  },
  "direct": {
    "title": "Contact direct, prin e-mail sau WhatsApp",
    "email": {
      "label": "Email: octavian@khromatik.com",
      "tooltip": "Copiere e-mail"
    },
    "whatsapp": "WhatsApp"
  }
}
